
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { BarChart2, Loader2 } from 'lucide-react';

interface TopProgressBarProps {
  isVisible: boolean;
  current: number;
  total: number;
  url?: string;
  title?: string;
}

export const TopProgressBar: React.FC<TopProgressBarProps> = ({
  isVisible,
  current,
  total,
  url,
  title = "Updating Engagement Metrics"
}) => {
  if (!isVisible) return null;

  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
  
  return (
    <div className="mb-6 p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-lg shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Loader2 className="h-5 w-5 animate-spin text-blue-600" />
          <h3 className="text-sm font-medium text-blue-900 dark:text-blue-100">
            {title}
          </h3>
        </div>
        <div className="text-sm font-semibold text-blue-700 dark:text-blue-300">
          {percentage}% ({current}/{total})
        </div>
      </div>
      
      <Progress 
        value={percentage} 
        className="h-2 mb-2 bg-blue-100 dark:bg-blue-900/30"
      />
      
      {url && (
        <div className="text-xs text-blue-600 dark:text-blue-400 truncate">
          Processing: {url}
        </div>
      )}
    </div>
  );
};
